<template>
  <div>
    <div class="row justify-content-center">
      <div class="col text-center">
        <h3>Welcome to the HRTec Survey Platform (HSP)</h3>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-8">
        <card>
          <div slot="header"><h4 class="card-title">{{ survey.surveyName }} Administration</h4></div>
          <div class="row">
            <div class="col-sm-12">
              <el-table :data="instances">
                <el-table-column min-width="200" label="Survey URL ID">
                  <template scope="scope">
                    <router-link :to="{ path: `/surveys/access/${hspSurveyId}/${scope.row.surveyUrlId}/review` }">{{ scope.row.surveyUrlId }}</router-link>
                  </template>
                </el-table-column>
                <el-table-column min-width="100" label="Created On">
                  <template scope="scope">{{ displayDate(scope.row.createdOn) }}</template>
                </el-table-column>
                <el-table-column min-width="100" label="Start Date">
                  <template scope="scope">{{ displayDate(scope.row.startDate) }}</template>
                </el-table-column>
                <el-table-column min-width="100" label="End Date">
                  <template scope="scope">{{ displayDate(scope.row.endDate) }}</template>
                </el-table-column>
                <el-table-column min-width="100" label="Access Type">
                  <template scope="scope">{{ scope.row.orgAccessTypeId }}</template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import { Table, TableColumn } from 'element-ui';
  import { formatDateDefault } from '../../modules/utils';

  export default {
    name: 'Welcome',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
        hspSurveyId: null,
        trueDisplayValue: 'Yes',
        falseDisplayValue: 'No'
      };
    },
    computed: {
      instances() {
        if(this.survey) {
          return this.survey.orgSurveys;
        }

        return [];
      },
      survey() {
        return this.$store.getters.getSurveyById(this.hspSurveyId) || {};
      },
    },
    methods: {
      displayDate: formatDateDefault('None'),
    },
    created() {
      this.hspSurveyId = this.$route.params.hspSurveyId;
    }
  };
</script>
<style>
  .cell {
    word-break: normal !important;
  }
</style>
